import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { MasterPlansRepository } from "../../repositories";
import { MasterPlanType } from "../../domain/models/master-plan-type";

@Injectable({ providedIn: 'root' })
export class GetMasterPlanTypesUseCase implements UseCase<null,MasterPlanType[]>{
    
    constructor(private readonly masterPlanRepository: MasterPlansRepository){
    }

    execute(): Observable<MasterPlanType[]>{
        return this.masterPlanRepository.getMasterPlanTypes();
    }
}